import { asset } from '../assets';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { ProductGallery } from '../components/ProductGallery';
import { NotesField } from '../components/NotesField';
import { CustomSizeField } from '../components/CustomSizeField';
import { QuoteActions } from '../components/QuoteActions';
import { usePageSetup } from '../hooks/usePageSetup';

const title = "Envelopes (Customized) - INGAZ Print";

function EnvelopesCustomized() {
  usePageSetup({ title });

  return (
    <>
      <SiteHeader />
        <main>
          <section className="product-details-section">
            <div className="product-container">
              <ProductGallery alt="Envelopes" images={[asset('assets/envelope_hero_1770050509184.png'), asset('assets/envelope_stack_1770050527920.png'), asset('assets/envelope_open_1770050549665.png'), asset('assets/envelope_detail_1770050567071.png')]} />
              <div className="product-info">
                <h1 className="product-title" data-en="Envelopes (Customized)" data-ar="المظاريف (مخصصة)">Envelopes (Customized)</h1>
                <p className="product-description" data-en="Custom printed envelopes for professional business correspondence and mailings." data-ar="مظاريف مطبوعة مخصصة للمراسلات التجارية والبريدية الاحترافية.">Custom printed envelopes for professional business correspondence and mailings.</p>
                <div className="key-features">
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/time.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Year-Round" data-ar="طوال العام">Year-Round</div>
                      <div className="feature-detail" data-en="12 months" data-ar="12 شهرًا">12 months</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/star.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Customizable" data-ar="قابل للتخصيص">Customizable</div>
                      <div className="feature-detail" data-en="Your images" data-ar="صورك">Your images</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/truck.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Fast Delivery" data-ar="تسليم سريع">Fast Delivery</div>
                      <div className="feature-detail" data-en="Quick turnaround" data-ar="إنجاز سريع">Quick turnaround</div>
                    </div>
                  </div>
                </div>
                <div className="product-benefits">
                  <h3 data-en="Why this product works" data-ar="لماذا يعمل هذا المنتج">Why this product works</h3>
                  <ul className="benefits-list">
                    <li data-en="Professional first impression for mail" data-ar="انطباع أول احترافي للبريد">Professional first impression for mail</li>
                    <li data-en="Multiple sizes for different needs" data-ar="أحجام متعددة لتلبية الاحتياجات المختلفة">Multiple sizes for different needs</li>
                    <li data-en="Reinforce brand identity with every mailing" data-ar="تعزيز هوية العلامة التجارية مع كل بريد">Reinforce brand identity with every mailing</li>
                    <li data-en="Quality paper stocks available" data-ar="أنواع ورق عالية الجودة متاحة">Quality paper stocks available</li>
                  </ul>
                </div>
                {/* Common Use Cases */}
                <div className="use-cases">
                  <h3 data-en="COMMON USE CASES" data-ar="حالات الاستخدام الشائعة">COMMON USE CASES</h3>
                  <div className="use-cases-grid">
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/bag.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Business Mail" data-ar="بريد الأعمال">Business Mail</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/star.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Invitations" data-ar="دعوات">Invitations</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/launch.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Direct Mail" data-ar="البريد المباشر">Direct Mail</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/store.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Corporate Comm" data-ar="اتصالات الشركات">Corporate Comm</div>
                    </div>
                  </div>
                </div>
                <QuoteActions configureOnly productType="Envelopes (Customized)" />
                <p className="help-text" data-en="Need help? Our design team is ready to assist you." data-ar="تحتاج مساعدة؟ فريق التصميم لدينا جاهز لمساعدتك.">Need help? Our design team is ready to assist you.</p>
              </div>
            </div>
          </section>
          <section className="configuration-section" id="configuration">
            <div className="config-container">
              <div className="config-main">
                <h2 data-en="Configure Your Customized Envelopes" data-ar="قم بتكوين المظاريف المخصصة الخاصة بك">Configure Your Customized Envelopes</h2>
                {/* Quantity (min 1000) */}
                <div className="config-group">
                  <label htmlFor="quantity" data-en="Quantity" data-ar="الكمية">Quantity</label>
                  <input type="number" id="quantity" placeholder="Minimum quantity of 1,000" min={1000} defaultValue={1000} data-placeholder-en="Minimum quantity of 1,000" data-placeholder-ar="الحد الأدنى 1,000" />
                  <p className="config-note"><em data-en="Minimum quantity of 1,000" data-ar="الحد الأدنى للكمية 1,000">Minimum quantity of 1,000</em></p>
                </div>
                {/* Size */}
                <div className="config-group">
                  <label data-en="Size" data-ar="الحجم">Size</label>
                  <div className="size-grid">
                    <div className="size-option active" data-size="DL" data-dims="110x220">DL<br /><span>110×220 mm</span></div>
                    <div className="size-option" data-size="C6" data-dims="114x162">C6<br /><span>114×162 mm</span></div>
                    <div className="size-option" data-size="C5" data-dims="162x229">C5<br /><span>162×229 mm</span></div>
                    <div className="size-option" data-size="C4" data-dims="229x324">C4<br /><span>229×324 mm</span></div>
                    <div className="size-option" data-size="Custom" data-dims="Custom"><span data-en="Custom" data-ar="مخصص">Custom</span><br /><span data-en="L × W" data-ar="الطول × العرض">L × W</span></div>
                  </div>
                  <CustomSizeField />
                </div>
                {/* Paper Type & Weight */}
                <div className="config-group">
                  <label htmlFor="paperType" data-en="Paper Type & Weight" data-ar="نوع الورق والوزن">Paper Type &amp; Weight</label>
                  <div className="paper-select-wrapper">
                    <img src={asset('assets/paper.svg')} alt="" className="paper-icon" />
                    <select id="paperType">
                      <option value="white-100" data-en="White paper 100 gsm" data-ar="ورق أبيض 100 جم">White paper 100 gsm</option>
                      <option value="white-120" data-en="White paper 120 gsm" data-ar="ورق أبيض 120 جم">White paper 120 gsm</option>
                      <option value="couche-130" data-en="Couche 130 gsm" data-ar="كوشيه 130 جم">Couche 130 gsm</option>
                      <option value="couche-150" data-en="Couche 150 gsm" data-ar="كوشيه 150 جم">Couche 150 gsm</option>
                      <option value="other" data-en="Other" data-ar="آخر">Other</option>
                    </select>
                  </div>
                </div>
                {/* Printed Colors */}
                <div className="config-group">
                  <label data-en="Printed Colors" data-ar="الألوان المطبوعة">Printed Colors</label>
                  <div className="color-options">
                    <div className="color-option active" data-color="colored">
                      <img src={asset('assets/palette.svg')} alt="" className="color-icon" />
                      <div className="color-dots">
                        <span className="dot red" />
                        <span className="dot green" />
                        <span className="dot blue" />
                      </div>
                      <span data-en="Full Color" data-ar="ألوان كاملة">Full Color</span>
                    </div>
                    <div className="color-option" data-color="bw">
                      <div className="color-dots">
                        <span className="dot black" />
                        <span className="dot white" />
                      </div>
                      <span data-en="Black & White" data-ar="أبيض وأسود">Black &amp; White</span>
                    </div>
                  </div>
                </div>
                {/* Printing Sides */}
                <div className="config-group">
                  <label data-en="Printing Sides" data-ar="الجوانب المطبوعة">Printing Sides</label>
                  <div className="side-options">
                    <div className="side-option active" data-sides="front-only"><span data-en="Front side only" data-ar="الجانب الأمامي فقط">Front side only</span></div>
                    <div className="side-option" data-sides="front-inside-flap"><span data-en="Front and inside flap" data-ar="الأمامي والرفرف الداخلي">Front and inside flap</span></div>
                  </div>
                </div>
                {/* Closure Type */}
                <div className="config-group">
                  <label data-en="Closure Type" data-ar="نوع الإغلاق">Closure Type</label>
                  <div className="lamination-options">
                    <label className="radio-option"><input type="radio" name="closureType" defaultValue="gummed" defaultChecked /><span data-en="Gummed (lick & seal)" data-ar="لاصق رطب (لحس وأغلق)">Gummed (lick &amp; seal)</span></label>
                    <label className="radio-option"><input type="radio" name="closureType" defaultValue="self-adhesive" /><span data-en="Self-adhesive (peel & seal)" data-ar="لاصق ذاتي (قشر وأغلق)">Self-adhesive (peel &amp; seal)</span></label>
                    <label className="radio-option"><input type="radio" name="closureType" defaultValue="no-closure" /><span data-en="No closure" data-ar="بدون إغلاق">No closure</span></label>
                  </div>
                </div>
                {/* Packaging */}
                <div className="config-group">
                  <label htmlFor="packaging" data-en="Packaging" data-ar="التعبئة والتغليف">Packaging</label>
                  <textarea id="packaging" placeholder="Describe your packaging requirements" rows={3} data-placeholder-en="Describe your packaging requirements" data-placeholder-ar="اوصف متطلبات التعبئة والتغليف" defaultValue={""} />
                </div>
                <div className="config-group">
                  <label data-en="Upload Artwork" data-ar="رفع التصميم">Upload Artwork</label>
                  <div className="upload-area" id="uploadArea">
                    <div className="upload-content">
                      <div className="upload-icon"><img src={asset('assets/upload.svg')} alt="" /></div>
                      <p data-en="Drop your files here or browse" data-ar="قم بإسقاط ملفاتك هنا أو تصفح">Drop your files here or browse</p>
                      <p className="upload-hint" data-en="Supports: PDF, AI, EPS, PNG, JPG, PSD (Max 100MB each)" data-ar="يدعم: PDF, AI, EPS, PNG, JPG, PSD (الحد الأقصى 100 ميجابايت لكل ملف)">Supports: PDF, AI, EPS, PNG, JPG, PSD (Max 100MB each)</p>
                    </div>
                    <input type="file" id="fileInput" multiple accept=".pdf,.ai,.eps,.png,.jpg,.jpeg,.psd" style={{display: 'none'}} />
                  </div>
                </div>
                <NotesField />
              </div>
              {/* Request Summary Sidebar */}
              <div className="request-summary">
                <h3 data-en="Request Summary" data-ar="ملخص الطلب">Request Summary</h3>
                <div className="summary-details">
                  <div className="summary-item"><span className="summary-label">Type:</span><span className="summary-value" id="summaryType">Customized</span></div>
                  <div className="summary-item"><span className="summary-label">Size:</span><span className="summary-value" id="summarySize">DL</span></div>
                  <div className="summary-item"><span className="summary-label">Paper:</span><span className="summary-value" id="summaryPaper">White paper 100 gsm</span></div>
                  <div className="summary-item"><span className="summary-label">Closure:</span><span className="summary-value" id="summaryClosure">Gummed</span></div>
                </div>
                <div className="delivery-estimate">
                  <strong data-en="Estimated Delivery" data-ar="التسليم المتوقع">Estimated Delivery</strong>
                  <div className="delivery-time" data-en="3-5 business days" data-ar="3-5 أيام عمل">3-5 business days</div>
                </div>
                <QuoteActions productType="Envelopes (Customized)" />
                <button className="btn3"><img src={asset('assets/phone.svg')} alt="" /> <span data-en="Contact Support" data-ar="اتصل بالدعم">Contact Support</span></button>
                <div className="guarantees">
                  <div className="guarantee-item" data-en="✓ Free design review" data-ar="✓ مراجعة تصميم مجانية">✓ Free design review</div>
                  <div className="guarantee-item" data-en="✓ Quality guarantee" data-ar="✓ ضمان الجودة">✓ Quality guarantee</div>
                  <div className="guarantee-item" data-en="✓ Fast turnaround" data-ar="✓ تسليم سريع">✓ Fast turnaround</div>
                </div>
              </div>
            </div>
          </section>
          {/* Why Choose INGAZ Section */}
          <section className="why-choose-section">
            <div className="why-choose-container">
              <h2 data-en="Why Choose INGAZ?" data-ar="لماذا تختار INGAZ؟">Why Choose INGAZ?</h2>
              <p className="why-choose-subtitle" data-en="Your trusted partner for professional printing solutions" data-ar="شريكك الموثوق لحلول الطباعة الاحترافية">Your trusted partner for professional printing solutions</p>
              <div className="why-choose-grid">
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/quality.svg')} alt="" /></div>
                  <h3 data-en="High Quality" data-ar="جودة عالية">High Quality</h3>
                  <p data-en="Premium materials and cutting-edge printing technology" data-ar="مواد عالية الجودة وتقنيات طباعة متطورة">Premium materials and cutting-edge printing technology
                  </p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/power.svg')} alt="" /></div>
                  <h3 data-en="Innovative Solutions" data-ar="حلول مبتكرة">Innovative Solutions</h3>
                  <p data-en="Modern printing techniques for exceptional results" data-ar="تقنيات طباعة حديثة لنتائج استثنائية">Modern printing techniques for exceptional results</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/time.svg')} alt="" /></div>
                  <h3 data-en="Fast Turnaround" data-ar="تسليم سريع">Fast Turnaround</h3>
                  <p data-en="Express delivery options available for urgent orders" data-ar="خيارات تسليم سريع متاحة للطلبات العاجلة">Express delivery options available for urgent orders</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/dollar.svg')} alt="" /></div>
                  <h3 data-en="Value for Money" data-ar="قيمة مقابل المال">Value for Money</h3>
                  <p data-en="Competitive pricing without compromising on quality" data-ar="أسعار تنافسية دون المساس بالجودة">
                    Competitive pricing without compromising on quality</p>
                </div>
              </div>
            </div>
          </section>
          {/* Related Products Section */}
          <section className="related-products-section">
            <div className="related-products-container">
              <h2 data-en="Related Products" data-ar="منتجات ذات صلة">Related Products</h2>
              <p className="related-subtitle" data-en="Explore our full range of printing services" data-ar="استكشف مجموعة كاملة من خدمات الطباعة">Explore our full range of printing services</p>
              <div className="related-products-grid">
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image1.webp')} alt="Business Cards" />
                  </div>
                  <h3 data-en="Business Cards" data-ar="بطاقات العمل">Business Cards</h3>
                  <p data-en="Professional business cards" data-ar="بطاقات عمل احترافية">Professional business cards</p>
                  <a href="/business-cards" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image5.webp')} alt="Brochures" />
                  </div>
                  <h3 data-en="Brochures" data-ar="الكتيبات">Brochures</h3>
                  <p data-en="Multi-page marketing material" data-ar="مواد تسويقية متعددة الصفحات">Multi-page marketing
                    material</p>
                  <a href="/brochures" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image3.webp')} alt="Leaflets" />
                  </div>
                  <h3 data-en="Leaflets" data-ar="المنشورات المطوية">Leaflets</h3>
                  <p data-en="Folded marketing materials" data-ar="مواد تسويقية مطوية">Folded marketing materials</p>
                  <a href="/leaflets" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image7.webp')} alt="Catalogs" />
                  </div>
                  <h3 data-en="Catalogs" data-ar="الكتالوجات">Catalogs</h3>
                  <p data-en="Product catalogs & lookbooks" data-ar="كتالوجات المنتجات والكتيبات">Product catalogs &amp; lookbooks
                  </p>
                  <a href="/catalogues" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image8.webp')} alt="Menus" />
                  </div>
                  <h3 data-en="Menus" data-ar="القوائم">Menus</h3>
                  <p data-en="Restaurant quality printing" data-ar="طباعة بجودة المطاعم">Restaurant quality printing</p>
                  <a href="/menus" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
              </div>
            </div>
          </section>
          {/* Footer */}
          <SiteFooter />
        </main>
    </>
  );
}

export default EnvelopesCustomized;
